import { GenericServices } from "./generic.services";
import Uri from "../common/uri/file-uri.constants";
import { ApiResponse } from "../models/app-configuration";

export class FileServices extends GenericServices {
  getDocumentPublishLink(fileName: string, isImage: boolean = false) {
    if (!fileName) {
      return;
    }

    let url = Uri.getPublishDocumentLink.replace(":fileName", fileName);

    if (isImage) {
      url += "?picture=true";
    }

    return super
      .executeSelecting(undefined, url)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }

  getSmallPicturePublishLink(fileName: string) {
    if (!fileName) {
      return;
    }

    let url = Uri.getSmallPublishPictureLink.replace(":fileName", fileName);
    
    return super
      .executeSelecting(undefined, url)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }
}
